// @ts-strict-ignore
import * as qs from 'query-string'

export function parseFixedFilters(str: string) {
  let obj = {}
  str.split('&').forEach((slice) => {
    const parsed = qs.parse(slice)
    Object.keys(parsed).forEach((key) => {
      obj[parseInt(key, 10)] = (parsed[key] as string)
        .split(',')
        .map((value) => parseInt(value, 10))
    })
  })

  return obj
}
